import { Container, Box } from '@mui/material'
interface PageContentProps {
  children: React.ReactNode
  // maxWidth?: 'xs' | 'xl' | 'sm' | 'md' | 'lg'
  container?: boolean
  sx?: any
}

export const PageContent = (props: PageContentProps) => {
  const { children, container, sx } = props

  if (container) {
    return (
      <Container
        style={{
          padding: '16px 16px 16px 16px'
          // minHeight: '100%'
        }}
        sx={sx}
      >
        {children}
      </Container>
    )
  }

  return (
    <Box
      sx={{
        padding: { xs: '24px 16px 16px 16px' }
      }}
    >
      {children}
    </Box>
  )
}

PageContent.defaultProps = {}
